/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectPaymentNotificationsResourceNotificationsInner
 */
export interface ProjectPaymentNotificationsResourceNotificationsInner {
    /**
     * 
     * @type {string}
     * @memberof ProjectPaymentNotificationsResourceNotificationsInner
     */
    deliverableId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectPaymentNotificationsResourceNotificationsInner
     */
    hasNotification: boolean;
}

/**
 * Check if a given object implements the ProjectPaymentNotificationsResourceNotificationsInner interface.
 */
export function instanceOfProjectPaymentNotificationsResourceNotificationsInner(value: object): value is ProjectPaymentNotificationsResourceNotificationsInner {
    if (!('deliverableId' in value) || value['deliverableId'] === undefined) return false;
    if (!('hasNotification' in value) || value['hasNotification'] === undefined) return false;
    return true;
}

export function ProjectPaymentNotificationsResourceNotificationsInnerFromJSON(json: any): ProjectPaymentNotificationsResourceNotificationsInner {
    return ProjectPaymentNotificationsResourceNotificationsInnerFromJSONTyped(json, false);
}

export function ProjectPaymentNotificationsResourceNotificationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPaymentNotificationsResourceNotificationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'deliverableId': json['deliverableId'],
        'hasNotification': json['hasNotification'],
    };
}

export function ProjectPaymentNotificationsResourceNotificationsInnerToJSON(value?: ProjectPaymentNotificationsResourceNotificationsInner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'deliverableId': value['deliverableId'],
        'hasNotification': value['hasNotification'],
    };
}

